'use strict'

import React, { useContext, useEffect, useState } from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'
import PageContext from '../Context/PageContext';
import { Popover } from '@blueprintjs/core';



function Helper(props: any) {

    /* elem can be string : 'selectedItem' | 'page' */
    const text = props.text;
    const img = props.img;

    const eleMColor = () => {
        return (
            <div className='helper-style' style={{maxWidth : 200}}>
                {text}
                {img != null ? <img style={{width: '100%', margin: '5px 0'}} src={process.env.REACT_APP_PUBLIC_URL + "/images/images-helper/" + img}></img> : ""}     
            </div>
        )
    }

    return (
        <div>
            <Popover content={eleMColor()} placement="auto" fill={true}>
                <div><img className="help-icon" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/help.svg"}></img></div>
            </Popover>
        </div>
    )

}

export default Helper